const campaignStatus = {
  active: "ACTIVE",
  inactive: "INACTIVE",
  scheduled: "SCHEDULED",
  deactivated: "DEACTIVATED"
};

export default campaignStatus;
